module.exports = {"id":"202151","name":"Konstantinos Stafylidis","rating":"75","photo":"./data/images/photos/3/202151.png","club":{"name":"Stoke City","logo":"./data/images/clubs/StokeCity.png"},"positions":["DG"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/KonstantinosStafylidis0.json
// module id = 2402
// module chunks = 0